module.exports = __webpack_public_path__ + "img/robot.08965e8d.svg";